import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d4b22c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-top":"12px"} }
const _hoisted_2 = { class: "contract-list-tab" }

import { computed, ref, onMounted } from 'vue';
import {
  XrkTable,
  XrkTableRef,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  BaseButton,
  useInputColumn,
  BaseToolTip,
  BaseTag,
  useCreateModal,
  BaseTabs,
  BaseTabPane,
  XrkMessageBox,
  useDatePickerColumn
} from 'xrk-components';

import {
  downloadContract,
  getContractType,
  listPage
} from '../data-source/apis';
import { useRoute, useRouter } from 'vue-router';
import { findDictLabel, removeEmpty } from '@/utils/formatter';
import {
  CONTRACT_STATUS,
  CONTRACT_TYPE,
  ContractStatus,
  ContractType,
  RoleType,
  SIGH_STATUS,
  SIGN_TYPE,
  SignType,
  TEMPLATE_TYPE,
  TRADE_STRUCTURE,
  VALIDITY_SEARCH_OPTIONS,
  ValiditySearchType
} from '../constants';
import CompanyInfoDialog from '../components/company-info-dialog.vue';
import TerminalStrategyCard from '../components/terminal-strategy-card.vue';
import IndustryContractRequirementCard from '../components/industry-contract-requirement-card.vue';
import { signContract } from '@/common/data-source/common/apis';
import { file, formatter } from '@/utils';
import { IS_PLATFORM_TYPE_1, IS_ASSISTANT } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-list',
  setup(__props) {

const router = useRouter();

// table Ref
const xrkTableRef = ref<XrkTableRef>(null);
const strategyCardRef = ref<InstanceType<typeof TerminalStrategyCard>>(null);

const contractType = ref(null);
const contractTypes = ref([]);
const route = useRoute();
const roleType = computed(() => route.meta?.role);

// 工业账号登录向日葵服务助手：去签约方式筛选/列、去签署按钮
const isIndustryXrk = computed(
  () => IS_ASSISTANT && roleType.value === RoleType.INDUSTRY
);

// 向日葵服务助手 · 终端人员合同 tab 门控
const isTerminalPersonTabXrk = computed(
  () => IS_ASSISTANT && contractType.value === ContractType.MARKET_PERSON
);

// 向日葵服务助手 · 市场服务/终端人员合同 tab
const isMarketOrPersonXrk = computed(
  () =>
    IS_ASSISTANT &&
    [ContractType.MARKET, ContractType.MARKET_PERSON].includes(
      contractType.value
    )
);

/** 合同有效期搜索类型（控制签署/上传时间筛选项显隐） */
const validitySearchType = computed(() => {
  return xrkTableRef.value?.getSearchValue()
    ?.validitySearchType as ValiditySearchType;
});

// 策略卡
const refreshStrategyCard = () => {
  if (isTerminalPersonTabXrk.value) {
    strategyCardRef.value?.refresh();
  }
};

const goTemplateMgmt = () => {
  router.push({
    path: `/main/contract-mgmt/${route.meta.roleText}/terminal-template`,
    query: { tab: contractType.value }
  });
};

const textOverflow = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

let partOpt = [];

// 向日葵服务助手·平台服务合同：不展示搜索区
const hidePlatformSearch = computed(
  () => IS_ASSISTANT && contractType.value === ContractType.PLATFORM
);

// 搜索项
const searchConfig = computed<XrkTableProps['searchConfig']>(() => ({
  searchBtn: { show: !hidePlatformSearch.value },
  resetBtn: { show: !hidePlatformSearch.value },
  searchColumns: hidePlatformSearch.value
    ? []
    : [
        useInputColumn({
          prop: 'contractName',
          type: 'input',
          label: '合同名称',
          config: {
            placeholder: '请输入合同名称',
            maxlength: 15
          }
        }),
        !(IS_ASSISTANT && contractType.value === ContractType.MARKET) &&
          useSelectColumn({
            prop: 'contractAttributes',
            label: '合同属性',
            config: {
              placeholder: '请选择',
              clearable: true,
              options: TEMPLATE_TYPE
            }
          }),
        useInputColumn({
          prop: 'firstPartyName',
          type: 'input',
          label: '甲方',
          config: {
            placeholder: '请输入甲方名称',
            maxlength: 50
          }
        }),
        useInputColumn({
          prop: 'secondPartyName',
          type: 'input',
          label: '乙方',
          config: {
            placeholder: '请输入乙方名称',
            maxlength: 50
          }
        }),
        !isIndustryXrk.value &&
          useSelectColumn({
            prop: 'lineType',
            label: '签约方式',
            config: {
              placeholder: '请选择',
              clearable: true,
              options: SIGN_TYPE
            }
          }),
        IS_PLATFORM_TYPE_1 &&
          [ContractType.MARKET_PERSON, ContractType.AGENCY_SERVICE].includes(
            contractType.value
          ) &&
          !(
            IS_ASSISTANT && contractType.value === ContractType.MARKET_PERSON
          ) &&
          useInputColumn({
            prop: 'individualName',
            type: 'input',
            label: '个体名称',
            config: {
              placeholder: '请输入个体名称',
              maxlength: 50
            }
          }),
        IS_PLATFORM_TYPE_1 &&
          !(
            IS_ASSISTANT &&
            [ContractType.MARKET, ContractType.MARKET_PERSON].includes(
              contractType.value
            )
          ) &&
          useSelectColumn({
            prop: 'taxPattern',
            label: '交易结构',
            config: {
              placeholder: '请选择',
              clearable: true,
              options: TRADE_STRUCTURE
            }
          }),
        useSelectColumn({
          prop: 'signingStatus',
          label: '合同状态',
          config: {
            placeholder: '请选择',
            clearable: true,
            options: CONTRACT_STATUS
          }
        }),
        isMarketOrPersonXrk.value &&
          useInputColumn({
            prop: 'code',
            label: '合同编号',
            config: {
              placeholder: '请输入合同编号',
              clearable: true,
              maxlength: 50
            }
          }),
        isMarketOrPersonXrk.value &&
          useSelectColumn({
            prop: 'validitySearchType',
            label: '合同有效期',
            config: {
              placeholder: '请选择',
              clearable: true,
              options: VALIDITY_SEARCH_OPTIONS
            },
            listener: {
              onChange: (val, searchValue) => {
                const values = searchValue as Record<string, any>;
                if (val === ValiditySearchType.LONG_TERM) {
                  values.validity = undefined;
                  values.validityStart = undefined;
                  values.validityEnd = undefined;
                  return;
                }
                if (val !== ValiditySearchType.NO_FIXED) {
                  values.validityStart = undefined;
                  values.validityEnd = undefined;
                  values.validity = undefined;
                }
              }
            }
          }),
        isMarketOrPersonXrk.value &&
          validitySearchType.value === ValiditySearchType.NO_FIXED &&
          useDatePickerColumn({
            prop: 'validity',
            label: '签署/上传时间',
            config: {
              type: 'daterange',
              startPlaceholder: '日期始',
              endPlaceholder: '日期止'
            },
            listener: {
              onChange: (activeValue, searchValue) => {
                const [validityStart, validityEnd] = activeValue || [
                  undefined,
                  undefined
                ];
                const values = searchValue as Record<string, any>;
                values.validityStart = validityStart;
                values.validityEnd = validityEnd;
              }
            },
            style: {
              width: '200px'
            }
          }),
        [ContractType.MARKET_PERSON, ContractType.AGENCY_SERVICE].includes(
          contractType.value
        ) &&
          IS_PLATFORM_TYPE_1 &&
          !(
            IS_ASSISTANT && contractType.value === ContractType.MARKET_PERSON
          ) &&
          useInputColumn({
            prop: 'parkName',
            type: 'input',
            label: '所属园区',
            config: {
              placeholder: '请输入所属园区',
              maxlength: 50,
              inputTextReplace: true,
              inputTexts: ['汉字', '英文字母']
            }
          })
      ].filter(Boolean),
  otherComponents: [
    {
      render() {
        // 向日葵服务助手·市场服务合同：服务商进入自助上传页（工业账号不展示）
        if (
          IS_ASSISTANT &&
          contractType.value === ContractType.MARKET &&
          roleType.value !== RoleType.INDUSTRY
        ) {
          return (
            <BaseButton
              type="primary2"
              click={() => {
                router.push({
                  path: `/main/contract-mgmt/${route.meta.roleText}/market-upload`,
                  query: { tab: contractType.value }
                });
              }}
            >
              上传
            </BaseButton>
          );
        }
        if ([ContractType.AGENCY_SERVICE].includes(contractType.value))
          return (
            <BaseButton
              type="primary2"
              click={() => {
                router.push({
                  path: `/main/contract-mgmt/${route.meta.roleText}/view`,
                  query: { tab: contractType.value }
                });
              }}
            >
              上传
            </BaseButton>
          );
        return <></>;
      }
    }
  ]
}));

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '合同编号',
      prop: 'code',
      minWidth: 300
    }),
    useTableColumn({
      label: '合同名称',
      prop: 'contractName',
      minWidth: 200
    }),
    useTableColumn({
      label: '合同属性',
      prop: 'contractAttributes',
      formatter: ({ cellValue }) => TEMPLATE_TYPE[cellValue]?.label || '-'
    }),
    useTableColumn({
      label: '甲方',
      showOverflowTooltip: false,
      width: 248,
      prop: 'firstPartyName',
      render: ({ row, cellValue }) =>
        setPartyTableContent(row, cellValue, 'firstParty', row.firstStatus)
    }),
    useTableColumn({
      label: '乙方',
      width: 248,
      showOverflowTooltip: false,
      prop: 'secondPartyName',
      render: ({ row, cellValue }) =>
        setPartyTableContent(row, cellValue, 'secondParty', row.secondStatus)
    }),
    !isIndustryXrk.value &&
      useTableColumn({
        label: '签约方式',
        prop: 'lineType',
        formatter: ({ cellValue }) => findDictLabel(SIGN_TYPE, +cellValue)
      }),
    useTableColumn({
      label: '合同状态',
      prop: 'signingStatus',
      width: 100,
      render: ({ cellValue }) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div style={{ marginRight: '4px' }}>
              {findDictLabel(CONTRACT_STATUS, +cellValue)}
            </div>
          </div>
        );
      }
    }),
    useTableColumn({
      label: '签署/上传时间',
      prop: 'signingFinishDt',
      formatter: ({ cellValue }) => formatter.date(cellValue),
      width: 180
    }),
    useTableColumn({
      label: '合同有效期',
      prop: 'validityEnd',
      // 4. 拒绝签署的显示“-”
      // 5. 已失效的显示失效时间
      // 1. 线上签署的显示合同模版规定的合同有效期显示
      // 2. 线下上传的显示上传时填写的有效期时间
      render: ({ row: { signingStatus, validityStart, validityEnd } }) => {
        if (signingStatus === ContractStatus.REJECTED) {
          return '-';
        }
        if (signingStatus === ContractStatus.EXPIRED) {
          return formatter.date(validityEnd);
        }
        return validityEnd === '长期' ? (
          '长期有效'
        ) : (
          <div>
            <span>{formatter.date(validityStart, 'YYYY-MM-DD')}</span>
            <span> - </span>
            <span>{formatter.date(validityEnd, 'YYYY-MM-DD')}</span>
          </div>
        );
      },
      width: 180
    }),
    IS_ASSISTANT &&
      contractType.value === ContractType.MARKET &&
      useTableColumn({
        label: '备注',
        prop: 'remark',
        showOverflowTooltip: true,
        minWidth: 160,
        formatter: ({ cellValue }) => cellValue || '-'
      }),
    useTableColumn({
      prop: 'handle',
      label: '操作',
      fixed: 'right',
      width: '200px',
      render: ({
        row: {
          id,
          lineType,
          contractRenderUrl,
          loginType,
          firstStatus,
          secondStatus,
          signingStatus,
          contractName
        }
      }) => {
        return (
          <>
            <BaseButton
              type="text"
              // 线上 且 签署中或未签约的时候 置灰
              disabled={
                lineType === SignType.ONLINE &&
                (+signingStatus !== ContractStatus.COMPLETED ||
                  !contractRenderUrl)
              }
              onClick={() => {
                // 向日葵服务助手·市场服务合同：「查看」直接打开在线预览（缩放/旋转由 FILE_VIEW_URL 提供）
                if (
                  IS_ASSISTANT &&
                  contractType.value === ContractType.MARKET
                ) {
                  if (contractRenderUrl) {
                    file.preview(contractRenderUrl);
                  }
                  return;
                }
                if (lineType === SignType.OFFLINE) {
                  router.push({
                    path: `/main/contract-mgmt/${route.meta.roleText}/view`,
                    query: { tab: contractType.value, id }
                  });
                  return;
                }
                // 线上签署的合同显示 e 签宝合同签署页面
                file.preview(contractRenderUrl);
              }}
            >
              查看
            </BaseButton>
            {!isIndustryXrk.value && (
              <BaseButton
                v-resource={[['签署合同']]}
                type="text"
                disabled={
                  lineType === SignType.OFFLINE ||
                  [ContractStatus.COMPLETED, ContractStatus.REJECTED].includes(
                    +loginType == 1 ? +firstStatus : +secondStatus
                  )
                }
                onClick={async () => {
                  const { data } = await signContract({ contractId: id });
                  if (!data.currentUrl) {
                    xrkTableRef.value?.initCurrentList();
                    return;
                  }
                  window.open(data.currentUrl);
                  XrkMessageBox.confirm(
                    `合同《${contractName}》是否已签约完成?`,
                    '提示',
                    {
                      confirmButtonText: '已完成',
                      cancelButtonText: '关闭'
                    }
                  ).finally(() => {
                    xrkTableRef.value?.initCurrentList();
                  });
                }}
              >
                签署
              </BaseButton>
            )}
            <BaseButton
              v-resource={[['下载']]}
              type="text"
              disabled={
                !(
                  [ContractStatus.COMPLETED, ContractStatus.EXPIRED].includes(
                    +signingStatus
                  ) && contractRenderUrl
                )
              }
              onClick={() => {
                downloadContract({ id });
              }}
            >
              下载
            </BaseButton>
          </>
        );
      }
    })
  ].filter(Boolean)
});

/** 甲乙方名称展示 */
const setPartyTableContent = (row, compName, partyType, signStatus) => {
  const { secondPartyId, firstPartyId, id, allianceUserType } = row;

  // 市场服务人员且乙方，为人名或个体户
  const showindividualName =
    partyType === 'secondParty' &&
    [ContractType.MARKET_PERSON, ContractType.AGENCY_SERVICE].includes(
      contractType.value
    ) &&
    +allianceUserType !== 1;

  return (
    <>
      <div style={{ display: 'flex' }}>
        <BaseTag
          effect="plain"
          type={SIGH_STATUS[signStatus]?.type}
          style="margin-right: 8px; padding: 0 6px; height: 25px"
        >
          {SIGH_STATUS[signStatus]?.label}
        </BaseTag>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column'
          }}
        >
          <BaseToolTip effect="dark" content={compName} placement="top-start">
            <BaseButton
              link
              type="primary2"
              v-show={compName}
              click={() => {
                const instant = useCreateModal(CompanyInfoDialog, {
                  id:
                    partyType === 'secondParty' ? secondPartyId : firstPartyId,
                  type: contractType.value,
                  // 只有市场服务人员且乙方，为人名或个体户，其他是公司
                  typeOfPartyAAndPartyB: partyType === 'secondParty' ? 2 : 1,
                  contractId: id,
                  onRemove: () => {
                    instant.remove();
                  }
                });
              }}
            >
              <p style={{ maxWidth: '140px', ...textOverflow }}>{compName}</p>
            </BaseButton>
          </BaseToolTip>
          {showindividualName && (
            <BaseToolTip
              effect="dark"
              content={row.individualName}
              placement="top-start"
            >
              <div style={{ maxWidth: '160px', ...textOverflow }}>
                {row.individualName}
              </div>
            </BaseToolTip>
          )}
        </div>
      </div>
    </>
  );
};

//获取当前登录者的合同类型
const getContractList = async () => {
  const types = (await getContractType({ roleType: roleType.value })) || [];
  if (types.length === 0) {
    return;
  }
  const queryTab = route.query.tab;
  if (queryTab && types.includes(+queryTab)) {
    contractType.value = +queryTab;
  } else {
    contractType.value = +types[0];
  }

  contractTypes.value = types.map(item => {
    const code = +item;
    // 向日葵服务助手：「市场服务人员合同」改名为「终端人员合同」
    const label =
      IS_ASSISTANT && code === ContractType.MARKET_PERSON
        ? '终端人员合同'
        : findDictLabel(CONTRACT_TYPE, item);
    return { value: code, label };
  });

  refreshStrategyCard();

  xrkTableRef.value?.initCurrentList?.();
};
onMounted(() => {
  getContractList();
});

const onTabChange = () => {
  xrkTableRef.value?.clearSearchValues();
  xrkTableRef.value?.initCurrentList();
  refreshStrategyCard();
};

/**
 * 获取列表
 */
const getListAjax = async params => {
  const {
    participantB,
    validityStart,
    validityEnd,
    validitySearchType: _validitySearchType,
    validity: _validity,
    ...rest
  } = params;
  const requestParams = { ...rest };
  if (participantB) {
    const partType = partOpt.find(
      item => +item.id === participantB
    )?.typeOfPartyAAndPartyB;
    requestParams[`participant${+partType === 1 ? 'A' : 'B'}`] = participantB;
  }
  return listPage(
    removeEmpty({
      ...requestParams,
      type: contractType.value,
      roleType: roleType.value,
      validityStart:
        validitySearchType.value === ValiditySearchType.LONG_TERM
          ? '长期'
          : validityStart,
      validityEnd:
        validitySearchType.value === ValiditySearchType.LONG_TERM
          ? '长期'
          : validityEnd
    })
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isIndustryXrk.value)
      ? (_openBlock(), _createBlock(IndustryContractRequirementCard, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      "request-now": false,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, {
      tableTop: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (contractTypes.value?.length > 1)
            ? (_openBlock(), _createBlock(_unref(BaseTabs), {
                key: 0,
                modelValue: contractType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contractType).value = $event)),
                onTabChange: onTabChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractTypes.value, (item) => {
                    return (_openBlock(), _createBlock(_unref(BaseTabPane), {
                      label: item.label,
                      name: item.value,
                      key: item.value
                    }, null, 8, ["label", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      tableBefore: _withCtx(() => [
        (isTerminalPersonTabXrk.value)
          ? (_openBlock(), _createBlock(TerminalStrategyCard, {
              key: 0,
              ref_key: "strategyCardRef",
              ref: strategyCardRef,
              onGoTemplate: goTemplateMgmt
            }, null, 512))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})